import { ActionTypeNames, ActionValues, createActionCreators } from '../../store/actions';
import { ThunkAction } from '../../store/middleware';

export const setRedirectUrlActions = createActionCreators<
	{ T: 'SET_REDIRECT_URL', P: { url: string } }
	>('SET_REDIRECT_URL');

export const setRedirectUrl = (url: string): ThunkAction => async (dispatch, getState, { _deprecatedApi: api }) => {
	dispatch(setRedirectUrlActions.SET_REDIRECT_URL({ url }));
};

type RedirectUrlActions = ActionValues<typeof setRedirectUrlActions>;
type RedirectUrlActionTypes = ActionTypeNames<RedirectUrlActions>;
export type Actions = RedirectUrlActions[keyof RedirectUrlActions];
export const ActionTypes = Object.keys(setRedirectUrlActions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as RedirectUrlActionTypes);
